import React from 'react';

const TypingIndicator = ({ typingUsers, currentUser }) => {
  if (!typingUsers || typingUsers.length === 0) {
    return null;
  }

  const filteredUsers = typingUsers.filter(user => user !== currentUser);

  if (filteredUsers.length === 0) {
    return null;
  }

  const getTypingText = () => {
    if (filteredUsers.length === 1) {
      return `${filteredUsers[0]} is typing...`;
    } else if (filteredUsers.length === 2) {
      return `${filteredUsers[0]} and ${filteredUsers[1]} are typing...`;
    } else {
      return `${filteredUsers[0]} and ${filteredUsers.length - 1} others are typing...`;
    }
  };

  return (
    <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400 italic">
      <div className="flex space-x-1">
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
      </div>
      <span>{getTypingText()}</span>
    </div>
  );
};

export default TypingIndicator;

